import React from 'react';
import useAppSelector from '../app/redux/useAppSelector';
import type { ButtonProps } from '../components/Button';
import Button from '../components/Button';
import Tooltip from '../components/Tooltip';
import memberIcon from '../icons/member.svg';
import useShowInvitationModal from './useShowInvitationModal';

interface InviteButtonProps {
  block?: boolean;
  showIcon?: boolean;
  size?: ButtonProps['size'];
}

const InviteButton = ({
  block,
  showIcon,
  size = 'regular',
}: InviteButtonProps) => {
  const isVerified = useAppSelector(
    (state) => state.session.organization.isVerified,
  );

  const showInvitationModal = useShowInvitationModal();

  const currentUser = useAppSelector((state) => state.session.user);
  if (currentUser.type === 'GUEST') {
    return null;
  }

  const inner = (
    <Button
      variant="secondary"
      onClick={showInvitationModal}
      disabled={!isVerified}
      block={block}
      icon={showIcon && memberIcon}
      size={size}
    >
      Invite teammates
    </Button>
  );

  return isVerified ? (
    inner
  ) : (
    <Tooltip
      trigger="hover"
      tooltip={
        'Inviting members is disabled until\nyour email has been verified'
      }
      placement="top"
      display={block ? 'block' : 'inline-block'}
    >
      {inner}
    </Tooltip>
  );
};

export default InviteButton;
